
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/brochure-downloads",
      function () {
        return require("private-next-pages/support/brochure-downloads/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/brochure-downloads"])
      });
    }
  